import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const FormPub = () => {
  return (
    <React.Fragment>
      <SEO title="Fill Online Public Registration Form | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Fill Online Public Registration Form"
        content="Public Registration"
        contentTwo="Fill Online Registration Form"
        linkage="/registration_pub"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <div className="reg-form">
            <iframe
              src="https://wj.qq.com/s2/24948316/lpjk/"
              // frameBorder={0}
              // allowFullSreen
            ></iframe>
          </div>
          <div className="back">
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration_pub"}
            >
              Back to Registration page
            </Link>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default FormPub;
